import {createEntityService} from 'utils/createEntityService';
import {ReferralSource} from 'types/referralSource';

export const ReferralSourceService = createEntityService<ReferralSource>({
  baseUrl: 'api/v1/referral_sources',
  entityName: 'referral_source',
});
